import { render, staticRenderFns } from "./FncMessageList.vue?vue&type=template&id=447d3332&"
import script from "./FncMessageList.vue?vue&type=script&lang=js&"
export * from "./FncMessageList.vue?vue&type=script&lang=js&"
import style0 from "./FncMessageList.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FncMessageList.vue"
export default component.exports